import axios from 'axios';
import { getBaseUrl, getRoomApiUrl, getpInfo, getpInfoAdmin } from '../socket';
import { getAcsLoginToken } from './acsToken';

const getIdempotencyKey = () => {
  if (window.crypto?.randomUUID) {
    return window.crypto.randomUUID();
  }

  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (char) => {
    const value = Math.random() * 16 | 0;
    const next = char === 'x' ? value : (value & 0x3 | 0x8);
    return next.toString(16);
  });
};

const getAuthHeaders = async () => {
  const { tokenAzureLogin } = await getAcsLoginToken();

  if (!tokenAzureLogin) {
    throw new Error('Unable to authenticate room request');
  }

  return {
    Authorization: `Bearer ${tokenAzureLogin}`,
    'Content-Type': 'application/json',
  };
};

export async function createRoom(userId, callBack) {
  try {
    const response = await axios.post(
      getRoomApiUrl(),
      {
        participantUserId: userId,
        idempotencyKey: getIdempotencyKey(),
      },
      {
        headers: await getAuthHeaders(),
        timeout: 30000,
      },
    );

    const room = response?.data?.data;
    if (!room?.acsRoomId) {
      throw new Error('Room creation response is missing room id');
    }

    callBack({
      acsRoomId: room.acsRoomId,
      adminlink: `${getBaseUrl()}?acsusrt=1&rmid=${room.acsRoomId}${getpInfoAdmin()}`,
      sellerLink: `${getBaseUrl()}?acsusrt=2&rmid=${room.acsRoomId}${getpInfo()}`,
    });
  } catch (error) {
    console.error('Room creation failed:', error?.response?.data?.message || error.message);
    throw error;
  }
}

export async function addParticipantToRoom(acsRoomId, userId, role = 'Presenter') {
  try {
    const response = await axios.post(
      `${getRoomApiUrl()}/participants`,
      {
        acsRoomId,
        participantUserId: userId,
        role,
      },
      {
        headers: await getAuthHeaders(),
        timeout: 30000,
      },
    );

    return response?.data?.data;
  } catch (error) {
    console.error('Unable to add participant to room:', error?.response?.data?.message || error.message);
    throw error;
  }
}
